import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import AboutImage from './AboutImage';
import { formatBranchAddress } from '../../utils/branchUtils';
import './about.css';

const BranchContact = ({ branch, settings }) => (
    <div className="space-y-3">
        <div className="flex items-start gap-2.5">
            <MapPin size={18} className="text-[#E31E24] shrink-0 mt-0.5" strokeWidth={2.5} />
            <span className="text-xs md:text-sm text-slate-700 leading-relaxed font-medium">
                {formatBranchAddress(branch.address) || branch.address || 'Đang cập nhật địa chỉ'}
            </span>
        </div>
        <div className="flex items-center gap-2.5">
            <Phone size={18} className="text-[#E31E24] shrink-0" strokeWidth={2.5} />
            <span className="text-xs md:text-sm font-bold text-slate-900">
                {branch.phone || settings?.hotline || 'Đang cập nhật'}
            </span>
        </div>
        <div className="flex items-center gap-2.5">
            <Clock size={18} className="text-[#E31E24] shrink-0" strokeWidth={2.5} />
            <span className="text-xs md:text-sm text-slate-600 font-medium">
                {branch.operatingHours || '7:30 - 18:00 (T2 - CN)'}
            </span>
        </div>
    </div>
);

const AboutBranchesSection = ({ title, branches, settings }) => {
    if (!branches?.length) return null;

    return (
        <section className="w-full bg-white py-10 lg:py-14 about-section-divider pb-20">
            <div className="about-shell">
                <div className="about-branch-title-line">
                    <h2 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight text-center shrink-0">
                        {title || 'HỆ THỐNG CHI NHÁNH'}
                    </h2>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
                    {branches.map((branch, idx) => {
                        const branchFallback = idx % 2 === 0
                            ? '/assets/images/khai-truong-ha-thanh-garage-chi-nhanh-thach-ban-long-bien-1-1.jpg'
                            : '/assets/images/hethong.jpg';

                        return (
                            <article key={branch._id || branch.id || idx} className="min-w-0 bg-slate-50/60 p-4 sm:p-5 rounded-2xl border border-slate-100 shadow-sm">
                                {/* Tên cơ sở màu đỏ nằm trên cùng, căn giữa */}
                                <h3 className="text-base md:text-lg font-black text-[#E31E24] uppercase text-center mb-4 tracking-wide leading-snug">
                                    {branch.name}
                                </h3>

                                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 md:gap-5">
                                    <div className="about-media-box about-media-box--branch shrink-0">
                                        <AboutImage
                                            src={branch.imageUrl}
                                            fallback={branchFallback}
                                            alt={branch.name}
                                            variant="cover"
                                        />
                                    </div>
                                    <div className="flex-1 min-w-0 pt-1">
                                        <BranchContact branch={branch} settings={settings} />
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default AboutBranchesSection;
